module.exports = __webpack_public_path__ + "img/banker-draw.a8fa9b36.svg";